import { combineReducers } from 'redux'

import { adminProfile } from './admin'
import { teamMembersProfile } from './teamMembers'

export const adminReducer = combineReducers({
  adminProfile,
  teamMembersProfile
})
